<agr-page-detail
  [pageTitle]="pageTitle()"
  data-test="create-ref-val-sheet__detail"
  (backAction)="back()"
  [hasPrimaryAction]="viewMode() !== viewModes.View"
  primaryActionIcon="save"
  [primaryActionText]="'save' | translate"
  (primaryAction)="save()"
>
  <ng-container actions>
    <div class="refvalsheet-detail__actions">
      <button
        mat-button
        class="button--text margin-right"
        (click)="openColumnSettings()"
        data-test="ref-val-sheet__columnsettings-button"
      >
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        {{ 'column-setting.title' | translate }}
      </button>

      <button
        *ngIf="viewMode() === viewModes.View"
        mat-flat-button
        color="accent"
        data-test="ref-val-sheet-detail__print"
        (click)="printRefValSheet()"
      >
        <mat-icon>print</mat-icon>{{ 'reference-value-sheet.create.print' | translate }}
      </button>
    </div>
  </ng-container>

  <agr-print-page
    [footerText]="'reference-value-sheet.create.title' | translate"
    [customizedLogoSrc]="customizedLogoSrc()"
    [showAgrifirmLogo]="showAgrifirmLogo()"
  >
    <div class="wrapper--spacing-horizontal">
      <div class="spacing--margin-horizontal spacing--margin-top">
        <!-- PRINT_ONLY CUSTOMER INFO HEADER -->
        <div class="print-only">
          <ul class="info-header" *ngIf="customer() as customer">
            <li>
              <label class="text-bold">
                {{ 'reference-value-sheet.print.farmcompany' | translate }}:
              </label>
              <label class="wide-label">
                {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
                {{ customer?.houseNumberAddition }},
                {{ customer?.city }}
              </label>
            </li>
            <li>
              <label class="text-bold">
                {{ 'reference-value-sheet.print.customernr' | translate }}:
              </label>
              <label>{{ customer?.externalId }}</label>
            </li>
            <li *ngIf="locationData() as location">
              <label class="text-bold">
                {{ 'reference-value-sheet.print.location' | translate }}:
              </label>
              <label class="wide-label">
                {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
                {{ location?.houseNumberAddition }},
                {{ location?.city }}
              </label>
            </li>
            <li>
              <label class="text-bold">
                {{ 'reference-value-sheet.create.created' | translate }}:
              </label>
              <label class="wide-label">
                {{ refValSheet()?.created | agrDate }}
              </label>
            </li>
            <li>
              <label class="text-bold">
                {{ 'reference-value-sheet.create.updated' | translate }}:
              </label>
              <label class="wide-label">
                {{ refValSheet()?.updated | agrDate }}
              </label>
            </li>
          </ul>
        </div>

        <form [formGroup]="refValSheetGroup">
          <div class="spacing--margin-top flex--row flex--wrap">
            <div
              *ngIf="viewMode() !== viewModes.View"
              class="flex--column spacing--margin-right field-width"
            >
              <mat-form-field class="flex__child--auto">
                <mat-label>{{ 'reference-value-sheet.create.name' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="name"
                  placeholder="{{ 'reference-value-sheet.create.name' | translate }}"
                  data-test="create-refvalsheet__name"
                />
                <mat-error *ngIf="refValSheetGroup.controls?.name.invalid">
                  {{ 'reference-value-sheet.create.error-name' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <ng-container *ngIf="!isNewRefValSheet()">
              <div class="flex--column screen-only">
                <p class="text--small">
                  <strong>{{ 'reference-value-sheet.create.created' | translate }}:</strong>
                  {{ refValSheet()?.created | agrDate }} - {{ refValSheet()?.createdAdvisorName }}
                </p>
              </div>
              <div class="flex--column spacing--margin-left screen-only">
                <p class="text--small">
                  <strong>{{ 'reference-value-sheet.create.updated' | translate }}:</strong>
                  {{ refValSheet()?.updated | agrDate }} - {{ refValSheet()?.updatedAdvisorName }}
                </p>
              </div>
            </ng-container>
          </div>

          <agr-table
            #refValSheetTable
            [config]="tableConfig()"
            emptyImage=""
            [emptyTitle]="'reference-value-sheet.create.no-day-values-title' | translate"
            [emptyDescription]="
              'reference-value-sheet.create.no-day-values-description' | translate
            "
            data-test="create-refvalsheet__table"
            [enableStepArrows]="false"
          ></agr-table>
          <ng-template #feedIntakeTotalTemplate>
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <input #feedIntakeTotalInput matInput disabled />
            </mat-form-field>
          </ng-template>
          <ng-template #deleteRowTemplate let-row="row">
            <ng-container *ngIf="viewMode() !== viewModes.View && isLastRow(row)">
              <mat-icon [ngStyle]="{ cursor: 'pointer' }" (click)="deleteDayValuesRow(row)"
                >delete</mat-icon
              >
            </ng-container>
          </ng-template>

          <ng-container class="screen-only" *ngIf="viewMode() !== viewModes.View">
            <div class="mat-button-row spacing--margin-top">
              <button
                *ngIf="hasDayValueRows()"
                type="button"
                mat-flat-button
                color="primary"
                data-test="create-refvalsheet__add-one-day-values-row"
                (click)="addOneDayValuesRow()"
              >
                <mat-icon>add</mat-icon>
                {{ 'reference-value-sheet.create.add-one-day-values-row' | translate }}
              </button>
              <div class="spacing--margin-top flex--row flex--wrap" *ngIf="!hasDayValueRows()">
                <div class="flex--column" style="width: 100px">
                  <mat-form-field class="flex__child--auto" style="width: 100px">
                    <mat-label>
                      {{ 'reference-value-sheet.create.number-of-days' | translate }}
                    </mat-label>
                    <input
                      matInput
                      agrNumber
                      [step]="1"
                      formControlName="numberOfDays"
                      placeholder="{{ 'reference-value-sheet.create.number-of-days' | translate }}"
                      data-test="create-refvalsheet__number-of-days"
                    />
                  </mat-form-field>
                </div>
                <div class="flex--column spacing--margin-left">
                  <button
                    style="margin-top: 15px"
                    type="button"
                    mat-flat-button
                    color="primary"
                    data-test="create-refvalsheet__add-multiple-day-values-rows"
                    [disabled]="hasNoNumberOfDays()"
                    (click)="addMultipleDayValuesRows()"
                  >
                    <mat-icon>add</mat-icon>
                    {{ 'reference-value-sheet.create.add-multiple-day-values-rows' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- SCREEN_ONLY DESCRIPTION -->
          <div class="spacing--margin-top">
            <agr-summary-card
              [title]="'reference-value-sheet.create.description' | translate"
              [canExpand]="true"
              [actions]="[]"
              class="screen-only"
            >
              <textarea
                *ngIf="viewMode() !== viewModes.View"
                class="text--small remarks__field"
                label="description"
                formControlName="description"
                rows="3"
                placeholder="{{
                  'reference-value-sheet.create.description-placeholder' | translate
                }}"
                data-test="create-refvalsheet__description"
              ></textarea>
              <p *ngIf="viewMode() === viewModes.View">
                {{ refValSheet()?.description }}
              </p>
            </agr-summary-card>
          </div>

          <div class="print-only">
            <ul class="info-header">
              <li>
                <label class="text-bold">
                  {{ 'reference-value-sheet.create.description' | translate }}:
                </label>
                <label class="wide-label">{{ refValSheet()?.description }}</label>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </agr-print-page>
</agr-page-detail>
